/**
 * 格式化工具函数
 * 提供数字格式化、日期格式化等功能
 */

/**
 * 将数字格式化为带千位分隔符的字符串
 * @param value 要格式化的数字或字符串
 * @param decimals 小数位数，默认为2
 * @param prefix 前缀，例如货币符号，默认为空
 * @returns 格式化后的字符串
 */
export const formatNumber = (value: number | string, decimals: number = 2, prefix: string = ''): string => {
  if (value === null || value === undefined || value === '') {
    return '0';
  }
  
  // 将输入转换为数字
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  // 检查是否为有效数字
  if (isNaN(num)) {
    return '0';
  }
  
  // 检查是否为整数
  const isInteger = Number.isInteger(num);
  
  // 格式化数字，添加千位分隔符
  const formattedNum = num.toLocaleString('en-US', {
    minimumFractionDigits: isInteger ? 0 : decimals,
    maximumFractionDigits: isInteger ? 0 : decimals
  });
  
  return `${prefix}${formattedNum}`;
};

/**
 * 格式化金额，添加美元符号
 * @param value 要格式化的金额
 * @param decimals 小数位数，默认为2
 * @returns 格式化后的金额字符串
 */
export const formatCurrency = (value: number | string, decimals: number = 2): string => {
  return formatNumber(value, decimals, '$');
};

/**
 * 格式化百分比
 * @param value 要格式化的百分比值（例如0.1234表示12.34%）
 * @param decimals 小数位数，默认为2
 * @param multiply100 是否将输入值乘以100，默认为false
 * @returns 格式化后的百分比字符串
 */
export const formatPercent = (value: number | string, decimals: number = 2, multiply100: boolean = false): string => {
  if (value === null || value === undefined || value === '') {
    return '0%';
  }
  
  // 将输入转换为数字
  let num = typeof value === 'string' ? parseFloat(value) : value;
  
  // 检查是否为有效数字
  if (isNaN(num)) {
    return '0%';
  }
  
  // 如果需要，将值乘以100
  if (multiply100) {
    num = num * 100;
  }
  
  // 检查是否为整数
  const isInteger = Number.isInteger(num);
  
  // 格式化数字，添加千位分隔符
  const formattedNum = num.toLocaleString('en-US', {
    minimumFractionDigits: isInteger ? 0 : decimals,
    maximumFractionDigits: isInteger ? 0 : decimals
  });
  
  return `${formattedNum}%`;
};
